import { UserLanguage } from './user.models';

export type TourStepPosition =
  | 'top'
  | 'top-start'
  | 'top-end'
  | 'bottom'
  | 'bottom-start'
  | 'bottom-end'
  | 'right'
  | 'right-start'
  | 'right-end'
  | 'left'
  | 'left-start'
  | 'left-end';

export interface TourStep {
  element: string | HTMLElement;
  position?: TourStepPosition;
  key: string;
  scrollTo?: boolean;
  popperOptions?: object;
  order?: number;
}

export enum TourInstance {
  AccountGroups = 'account-groups',
  KeyFigures = 'key-figures',
  ManageUsers = 'manage-users',
  Notifications = 'notifications',
  NotificationSettings = 'notification-settings',
  OptimizationSettings = 'optimization-settings',
  ProductAdsSync = 'product-ads-sync',
  ProductAdsSyncDrawer = 'product-ads-sync-drawer',
  Rules = 'rules',
  RulesSimpleMode = 'rules-simple-mode',
  RulesEdit = 'rules-edit-dialog',
  RulesEditDrawer = 'rules-edit-drawer',
  Scenarios = 'scenarios',
  Suggestions = 'suggestions',
  Subscription = 'subscription',
  BudgetSuggestions = 'budget-suggestion',
}

export enum TourIntercom {
  GoalsMain = 'goals-main',
}

export const tourIntercoms: Record<
  TourIntercom,
  { options?: { splitBySegment?: boolean } } & Record<UserLanguage, number | [number, number]>
> = {
  [TourIntercom.GoalsMain]: {
    options: {
      splitBySegment: true,
    },
    EN: [629693, 634012],
    DE: [633803, 634013],
    ZH: [633810, 634014],
  },
};
